var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSupportingDocumentWebIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "description_black_24dp",
    xmlns: "http://www.w3.org/2000/svg",
    width: 21.323,
    height: 21.323,
    viewBox: "0 0 21.323 21.323",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_17541",
    "data-name": "Path 17541",
    d: "M0,0H21.323V21.323H0Z",
    fill: "none"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_17542",
    "data-name": "Path 17542",
    d: "M7.554,14.439h7.108v1.777H7.554Zm0-3.554h7.108v1.777H7.554ZM12.885,2H5.777A1.782,1.782,0,0,0,4,3.777V17.992a1.775,1.775,0,0,0,1.768,1.777H16.439a1.782,1.782,0,0,0,1.777-1.777V7.331Zm3.554,15.992H5.777V3.777H12V8.219h4.442Z",
    transform: "translate(-0.446 -0.223)",
    fill: "#0074b0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupportingDocumentWebIcon);
export default __webpack_public_path__ + "static/media/supportingDocument-webIcon.1a6970a9b77babe24084976a0178e5bf.svg";
export { ForwardRef as ReactComponent };